import script from "./AccountLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountLog.vue?vue&type=script&setup=true&lang=ts"

import "./AccountLog.vue?vue&type=style&index=0&id=34b0aaf0&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b0aaf0"]])

export default __exports__